import { useSoloLectura } from '../../auth'

/** Vacía el registro de movimientos (spec 024 · FR-002). */
export function BotonVaciarAuditoria({
    vaciando,
    vacio,
    alVaciar,
}: {
    vaciando: boolean
    vacio: boolean
    alVaciar: () => void
}) {
    const soloLectura = useSoloLectura()
    if (soloLectura) return null
    return (
        <button
            type="button"
            disabled={vaciando || vacio}
            onClick={() => {
                if (
                    window.confirm(
                        'Se vacía el registro de este negocio, también lo que apuntó el asistente. Las citas de la agenda no se tocan. ¿Seguir?',
                    )
                ) {
                    alVaciar()
                }
            }}
            className="min-h-11 rounded-md border border-neutral-700 px-3 py-1.5 text-xs text-neutral-300 hover:bg-neutral-800 disabled:opacity-40 md:min-h-0"
        >
            {vaciando ? 'Vaciando…' : 'Vaciar registro'}
        </button>
    )
}
